module.exports = __webpack_public_path__ + "static/media/wonderly_brand_banner.d1b17857.jpg";